"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetLookUpsQueryDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const constants_1 = require("../../../../../service-lib/src/lib/constants");
class GetLookUpsQueryDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
    }
}
exports.GetLookUpsQueryDto = GetLookUpsQueryDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], GetLookUpsQueryDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Max)(100, { message: "Limit must be less than or equal to 100" }),
    tslib_1.__metadata("design:type", Number)
], GetLookUpsQueryDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetLookUpsQueryDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], GetLookUpsQueryDto.prototype, "searchId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetLookUpsQueryDto.prototype, "sortBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(["ASC", "DESC"], {
        message: "sortOrder must be either ASC or DESC",
    }),
    tslib_1.__metadata("design:type", String)
], GetLookUpsQueryDto.prototype, "sortOrder", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetLookUpsQueryDto.prototype, "searchBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetLookUpsQueryDto.prototype, "lookUpName", void 0);
